import React, { useEffect, useState } from "react";
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TableHead from '@mui/material/TableHead';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Badge from '@mui/material/Badge';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from "axios";
import swal from "sweetalert";
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import { useHistory } from "react-router-dom";
import Input from '@mui/material/Input';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { useDeadline } from "../../../../contexts/DeadlineContext";
interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number,
  ) => void;
}

function TablePaginationActions(props: TablePaginationActionsProps) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}



const IndexEmailTemplate = () => {
  const history = useHistory();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [permissions, setrPermissions] = useState([]);
  const [abstractRegEmailTemp, setAbstractRegEmailTemp] = React.useState([]);
  const [emailTemplateTitle, setEmailTemplateTitle] = useState(false);
  const eventid = localStorage.getItem('eventid');
  useEffect(() => {
    axios.get(`api/getpermissionByRole`).then(res => {

      if (res.status === 200) {
        const datad = res.data.data.permissions;
        setrPermissions(datad)

      } else {

      }


    })

  }, []);


  React.useEffect(() => {
    axios.get(`api/index-abstract-registration-email-template?id=${eventid}`).then(res => {

      if (res.status === 200) {
        const abstractRegTempData = res.data.AbstractEmailTemp;
        setAbstractRegEmailTemp(abstractRegTempData)

      } else {
        swal('Error', "Check API Something Wrong", 'error');

      }
    })

  }, []);





  const [searchTerm, setSearchTerm] = useState('');
  const filteredPosts = abstractRegEmailTemp?.filter((row) =>
    (row.subject && row.subject.toLowerCase().includes(searchTerm.toLowerCase()))
    // Add more fields as needed
  );
  const totalRecords = abstractRegEmailTemp.length;
  const filteredRecordsCount = filteredPosts.length;

  //for model open'
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenForEdit] = useState(false);
  const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();
  //for Single Record  show
  const [singleData, setSingleData] = useState({
    id: '',
    title: '',
    description: '',
    event_id: "",
    parent_id: "",
    status: "",
    updated_at: "",
    created_by: "",
    created_at: "",


  });

  // const handleClickShowSingleRecord = (id) => {

  //   axios.get(`api/abstractCategoryShow/${id}`).then(res => {

  //     if (res.status === 200) {
  //       const data = res.data;
  //       setSingleData(data)


  //     } else {
  //       swal('Error', "Check API Something Wrong", 'error');
  //     }
  //   })
  //   setOpen(true);
  // };
  const handleClose = () => {
    setOpen(false);
  };

  // Edit
  const [editabstractRegEmailTemp, setEditabstractRegEmailTemp] = useState({
    email_template_title: {
      id: '',
    },
    title: '',
    subject: '',
    variables: '',
  });
  const handleClickEditRecord = (id) => {


    axios.get(`api/edit-abstract-registration-email-template/${id}`).then(res => {

      if (res.data.status === 200) {
        const data = res.data.exitAbstRegTemp;

        setEditabstractRegEmailTemp(data)


      } else {
        swal('Error', "Check API Something Wrong", 'error');
      }
    })
    setOpenForEdit(true);
  };


  const insertVariable = (variable) => {
    const input = document.getElementById('emailVariablesInput');

    const cursorPosition = input.selectionStart;

    const currentValue = editabstractRegEmailTemp.variables;

    const newValue = currentValue.slice(0, cursorPosition) + variable + currentValue.slice(cursorPosition);

    setEditabstractRegEmailTemp({
      ...editabstractRegEmailTemp,
      variables: newValue
    });

    setTimeout(() => {
      input.selectionStart = input.selectionEnd = cursorPosition + variable.length;
    }, 0);
  };

  const handleCloseEdit = () => {
    setOpenForEdit(false);
  };

  const handleInput = (e) => {
    e.persist();
    setEditabstractRegEmailTemp({ ...editabstractRegEmailTemp, [e.target.name]: e.target.value });
  }
  const categoryStatus = editabstractRegEmailTemp.status;
  const [status, setStatus] = React.useState('');
  // const handleChange = (e) => {
  //   setStatus(e.target.value);
  // };
  useEffect((e) => {
    setStatus(categoryStatus)
  }, [categoryStatus]);


  useEffect(() => {
    axios.get(`/api/get-abstract-template-title?id=${eventid}`).then(res => {
      if (res.status === 200 && Array.isArray(res.data.gett)) {
        setEmailTemplateTitle(res.data.gett);
      }

    });

  }, []);
  // const handleSelectChange = (event) => {
  //   const selectedValue = event.target.value; // Get the selected value (id)
  //   setEditabstractRegEmailTemp((prev) => ({
  //     ...prev,
  //     title: selectedValue,
  //   }));
  // };
  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setEditabstractRegEmailTemp((prevState) => ({
      ...prevState,
      email_template_title: {
        ...prevState.email_template_title,
        id: value,
      },
    }));
  };


  // Update
  const upadteAbstractRegTempSubmit = (e, id) => {
    e.preventDefault();
    const data = {
      id: editabstractRegEmailTemp.id,
      title_id: editabstractRegEmailTemp.email_template_title.id,
      email_subject: editabstractRegEmailTemp.subject,
      email_variables: editabstractRegEmailTemp.variables,
    };

    axios.post(`api/update-abstract-registration-email-template/${data.id}`, data).then(res => {
      if (res.data.status === 200) {
        swal('Success', res.data.message, 'success');
        setOpenForEdit(false);

        // Refetch updated data
        axios.get(`api/index-abstract-registration-email-template?id=${eventid}`).then(res => {
          if (res.status === 200) {
            const abstractRegTempData = res.data.AbstractEmailTemp;
            setAbstractRegEmailTemp(abstractRegTempData); // Update the state with new data
          } else {
            swal('Error', "Unable to fetch updated data", 'error');
          }
        });
      } else {
        setEditabstractRegEmailTemp({ ...editabstractRegEmailTemp, error_list: res.data.validate_error });
      }
    });
  };

  // const upadteAbstractRegTempSubmit = (e, id) => {
  //   e.preventDefault();
  //   const data =
  //   {
  //     id: editabstractRegEmailTemp.id,
  //     email_title: editabstractRegEmailTemp.title,
  //     email_subject: editabstractRegEmailTemp.subject,
  //     email_variables: editabstractRegEmailTemp.variables,

  //   }
  //   axios.post(`api/update-abstract-registration-email-template/${data.id}`, data).then(res => {
  //     if (res.data.status === 200) {
  //       swal('Success', res.data.message, 'success');
  //       //history.push('/admin/abstract/add-category');
  //       setOpenForEdit(false);
  //       setAbstractRegEmailTemp(abstractRegEmailTemp)

  //     }
  //     else {

  //       setEditabstractRegEmailTemp({ ...editabstractRegEmailTemp, error_list: res.data.validate_error })

  //     }

  //   });
  // }

  const abstractCategoryDelete = (e, id) => {

    e.preventDefault();
    const thisClicked = e.currentTarget;
    thisClicked.innerText = " Deleting..."

    axios.get(`api/abstract-category-status/${id}`).then(res => {

      if (res.data.status === 200) {
        //swal("Success", res.data.message, "success");
        thisClicked.closest("tr").remove();

      }
      else if (res.data.status === 404) {
        this.innText = "delete";
      }
    });

  }

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - abstractRegEmailTemp.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };





  let backGroundButtonByEvent = "";
  if (eventid) {
    backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
  }
  else {
    backGroundButtonByEvent = '#145348'; // Default background color
  }

  return (
    <div style={{ margin: '1%', width: '100vw', marginLeft: '0%' }}>
      <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>

        <Card sx={{ width: '82vw', float: 'center' }} >
          <CardContent >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography component="h1" variant="h5">
                Abstract Email Templates
              </Typography>
              Total Records: {totalRecords} | Filtered Records: {filteredRecordsCount}
              <Grid item xs={8} >
                <TextField
                  fullWidth
                  label="Filter By: title "
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Grid>
            </div>
            {
              permissions['p_abstract-article-categoy-create'] === true ?
                <Button sx={{
                  float: 'right',
                  marginRight: '1%',
                  backgroundColor: backGroundButtonByEvent,
                  marginTop: '2%',
                  ":hover": {
                    color: "white"
                  },

                }}
                  color='success'
                  size='small'
                  variant='contained'
                  component={Link}
                  to="/admin/abstract/add-template">
                  Add New
                </Button> : ""
            }
            <Box component="form" noValidate sx={{ mt: 3 }}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
                  <TableHead>
                    <TableRow sx={{ color: '#FFFFFF' }}>
                      <TableCell > #</TableCell>
                      <TableCell align="center"> Title</TableCell>
                      <TableCell align="center">Subject</TableCell>
                      <TableCell align="center">Variables</TableCell>
                      <TableCell align="right">Status</TableCell>
                      <TableCell align="center" style={{ width: 260 }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>

                    {(rowsPerPage > 0
                      ? filteredPosts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : filteredPosts
                    ).map((row, i) => (
                      <TableRow key={row.id}>
                        <TableCell component="th" scope="row" style={{ width: 20 }}>
                          {i + 1}
                        </TableCell>
                        <TableCell style={{ width: 60 }} align="center">
                          {row.title_id !== 0 ? row.email_template_title?.title : "No Title"}
                        </TableCell>
                        <TableCell style={{ width: 60 }} align="center">
                          {row.subject}
                        </TableCell>
                        <TableCell style={{ width: 60 }} align="center">
                          {row.variables}
                        </TableCell>

                        <TableCell style={{ width: 160 }} align="right">
                          {row.status === 1 ? (
                            <Badge badgeContent="Active" color="success" />
                          ) : (
                            <Badge badgeContent="Inactive" color="secondary" />
                          )}
                        </TableCell>
                        <TableCell style={{ width: 160 }} align="right">
                          <Button
                            sx={{
                              ":hover": { color: "white" },
                              backgroundColor: backGroundButtonByEvent,
                            }}
                            color="primary"
                            size="small"
                            variant="contained"
                            component={Link}
                            to={`/admin/abstract/email-template/${row.id}`}
                          >
                            <VisibilityIcon />
                          </Button>

                          {permissions["p_abstract-article-categoy-edit"] && (
                            <Button
                              sx={{
                                margin: 1,
                                backgroundColor: backGroundButtonByEvent,
                                ":hover": { color: "white" },
                              }}
                              color="primary"
                              size="small"
                              variant="contained"
                              onClick={(e) => handleClickEditRecord(row.id)}
                            >
                              <EditNoteIcon />
                            </Button>
                          )}

                          {permissions["p_abstract-article-categoy-delete"] && (
                            <Button
                              sx={{
                                ":hover": { color: "white" },
                                backgroundColor: backGroundButtonByEvent,
                              }}
                              color="primary"
                              size="small"
                              variant="contained"
                              onClick={(e) => abstractCategoryDelete(e, row.id)}
                            >
                              <DeleteIcon />
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}

                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={3}
                        count={filteredPosts.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          ID: {singleData.id}
          <br />
        </DialogTitle>
        <DialogTitle id="alert-dialog-title">
          Title: {singleData.title}.
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">

            Descriptions: {singleData.description}.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <IconButton onClick={handleClose} >
            <CancelIcon />
          </IconButton>
        </DialogActions>
      </Dialog>

      {/* for Edit */}

      <Dialog
        open={openEdit}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Edit Record of ID {editabstractRegEmailTemp.id}
        </DialogTitle>
        <DialogTitle id="alert-dialog-title">
          Title: {editabstractRegEmailTemp.email_template_title?.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please, edit the abstractRegEmailTemp  of your Requrments.
          </DialogContentText>
          <br />
          {/* <TextField
            autoFocus
            margin="dense"
            id="firstName"
            label="Add Title"
            type="text"
            fullWidth
            name='title'
            onChange={handleInput} value={editabstractRegEmailTemp.title}
          /> */}
          <Grid item xs={6}>
            <FormControl fullWidth required error={!!editabstractRegEmailTemp.error_list?.title}>
              <Select
                name="title"
                value={editabstractRegEmailTemp?.email_template_title?.id || ''}
                onChange={handleSelectChange}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select an Email Title
                </MenuItem>
                {emailTemplateTitle && emailTemplateTitle.map((templateTitle) => (
                  <MenuItem key={templateTitle.id} value={templateTitle.id}>
                    {templateTitle.title}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{editabstractRegEmailTemp.error_list?.title}</FormHelperText>
            </FormControl>
          </Grid>
          <TextField
            autoFocus
            margin="dense"
            id="firstNamee"
            label="Add subject"
            type="text"
            fullWidth
            name='subject'
            onChange={handleInput} value={editabstractRegEmailTemp.subject}
          />
          <TextField
            margin="dense"
            id="emailVariablesInput"
            label="Add Variables"
            name='variables'
            onChange={handleInput} value={editabstractRegEmailTemp.variables}
            multiline
            fullWidth
            rows={6}
            required
          />
          <Grid item xs={12}>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{name}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Insert Name
            </Button>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{email}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Insert Email
            </Button>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{password}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Insert Password
            </Button>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{abstract_title}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Abstract Title
            </Button>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{conference_name}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Conference Name
            </Button>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{issues}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Issue
            </Button>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{submision_type}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Submision Type
            </Button>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{submision_type}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Submision Type
            </Button>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{date}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Date
            </Button>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{time}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Time
            </Button>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{header_image}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Header Banner
            </Button>
            <Button
              variant="outlined"
              onClick={() => insertVariable('{footer_image}')}
              sx={{ marginRight: 1 }} // Adds a small space (1 unit) to the right of the button
            >
              Footer
            </Button>
            {/* <Button variant="outlined" onClick={() => insertVariable('{qrcode}')}>Insert QR Code</Button> */}
          </Grid>

          <FormControl
            margin="dense"
            fullWidth>
            <InputLabel >Status</InputLabel>
            <Select
              name='status'
              label="Status"
              onChange={(e) => setStatus(e.target.val)} value={status} >

              <MenuItem value={1} >Active</MenuItem>
              <MenuItem value={0}>InActive</MenuItem>
            </Select>
          </FormControl>

        </DialogContent>
        <DialogActions >
          <Button onClick={handleCloseEdit} color="primary">
            Cancel
          </Button>
          <Button onClick={upadteAbstractRegTempSubmit} color="primary">
            Submit
          </Button>

        </DialogActions>
        <DialogActions>
          {/* <IconButton onClick={handleCloseEdit} >
            <CancelIcon />
          </IconButton> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default IndexEmailTemplate;
